import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocationMarketDto, LocationMarketsRequestDto } from '../dto';

@Injectable()
export class LocationMarketsApiService {
  private http = inject(HttpClient);

  private route = 'markets';

  getLocationMarkets(
    data: LocationMarketsRequestDto,
  ): Observable<LocationMarketDto[]> {
    return this.http.post<LocationMarketDto[]>(
      `${this.route}/offer-page/list`,
      data,
    );
  }
}
